import { render, staticRenderFns } from "./RateInfo.vue?vue&type=template&id=86bdbbc4"
import script from "./RateInfo.vue?vue&type=script&lang=js"
export * from "./RateInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports